import React from "react";
import Card from "../card";
import MainImage from "../image";

const WizardList = ({
  itemList,
  onClick,
  id,
}) => {
  return (
    <>
      <section className={"wizard-container"}>
        {itemList?.map((item) => {
          return (
            <Card
              title={item.name}
              key={item.id}
              onClick={() => {
                onClick(item);
              }}
              className={`${id === item.id ? "" : "disabled"}  wizard-item`}
            >
              <section className="wizard-item-img-container">
                <MainImage src={item.img} alt="Test img" />
              </section>
            </Card>
          );
        })}
      </section>
    </>
  );
};

export default WizardList;
